import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../core/interceptor/language.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @Input() currentUser: any = null;
  @Input() customerName: string = '';
  @Input() customerLogo: string | null = null;
  @Input() defaultImage: string = './../assets/defaultImage.webp';

  @Output() toggleMobileSidebar = new EventEmitter<void>();
  @Output() logoutRequested = new EventEmitter<void>();

  @ViewChild('userDropdownRef') userDropdownRef?: ElementRef;
  @ViewChild('langDropdownRef') langDropdownRef?: ElementRef;

  showUserMenu: boolean = false;
  showLangMenu: boolean = false;
  currentLang: string = 'fr';

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.currentLang = this.languageService.getCurrentLanguage();
  }

  toggleUserMenu(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.showUserMenu = !this.showUserMenu;
    this.showLangMenu = false;
  }

  toggleLangMenu(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.showLangMenu = !this.showLangMenu;
    this.showUserMenu = false;
  }

  changeLanguage(lang: string): void {
    this.currentLang = lang;
    this.languageService.setLanguage(lang);
    this.showLangMenu = false;
  }

  getUserDisplayName(): string {
    if (this.currentUser?.firstName || this.currentUser?.lastName) {
      return `${this.currentUser.firstName || ''} ${this.currentUser.lastName || ''}`.trim();
    }
    return this.currentUser?.login || this.currentUser?.email || 'Utilisateur';
  }

  getUserRoleLabel(): string {
    const authorities: string[] = this.currentUser?.authorities || [];
    if (authorities.includes('ROLE_ADMIN') || authorities.includes('ROLE_JUBOO_AGENT')) {
      return 'BACKOFFICE.HEADER.ROLE_ADMIN';
    }
    return 'BACKOFFICE.HEADER.ROLE_AGENT';
  }

  onLogout(): void {
    this.showUserMenu = false;
    this.logoutRequested.emit();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as Node;

    if (
      this.showUserMenu &&
      this.userDropdownRef &&
      !this.userDropdownRef.nativeElement.contains(target)
    ) {
      this.showUserMenu = false;
    }

    if (
      this.showLangMenu &&
      this.langDropdownRef &&
      !this.langDropdownRef.nativeElement.contains(target)
    ) {
      this.showLangMenu = false;
    }
  }
}
